<tui-root>
  <ngx-loading-bar [height]="'3px'" [includeSpinner]="false" [color]="'#0076ff'"/>
  <nb-layout class="zero-padding">
    <nb-layout-column class="zero-padding">
      <router-outlet></router-outlet>
    </nb-layout-column>
  </nb-layout>
</tui-root>
